export default defineNuxtPlugin(() => {
  const { hasFeature } = useAuth()
  return {
    provide: {
      hasFeature,
    },
  }
})
